import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Pencil, X } from "lucide-react";

const empty = { grupo: "", name: "" };

const AdminAlianzas = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);

  const load = () => api.get("/alianzas").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const grupos = [...new Set(items.map((i) => i.grupo))];
  const reset = () => { setForm(empty); setEditingId(null); };

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) { await api.put(`/alianzas/${editingId}`, form); toast.success("Aliado actualizado"); }
      else { await api.post("/alianzas", form); toast.success("Aliado agregado"); }
      reset(); load();
    } catch { toast.error("No se pudo guardar"); }
  };
  const edit = (a) => { setEditingId(a.id); setForm({ grupo: a.grupo, name: a.name }); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const remove = async (id) => { if (!window.confirm("¿Eliminar este aliado?")) return; await api.delete(`/alianzas/${id}`); toast.success("Eliminado"); if (editingId === id) reset(); load(); };

  return (
    <div className="mt-8">
      <form onSubmit={submit} data-testid="alianza-form" className="bg-white border border-[#E5E5E5] rounded-sm p-6 mb-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading text-lg font-bold text-brand-ink">{editingId ? "Editar aliado" : "Agregar aliado"}</h2>
          {editingId && <button type="button" onClick={reset} data-testid="alianza-cancel" className="inline-flex items-center gap-1 text-sm text-brand-ink/60"><X size={15} /> Cancelar</button>}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="text-xs font-semibold text-brand-ink/70">Grupo / categoría</label>
            <input required list="grupos-list" data-testid="alianza-grupo" value={form.grupo} onChange={(e) => setForm({ ...form, grupo: e.target.value })} className="mt-1 w-full border border-[#E5E5E5] rounded-sm px-3 py-2 text-sm outline-none focus:border-brand-magenta" />
            <datalist id="grupos-list">{grupos.map((g) => <option key={g} value={g} />)}</datalist>
          </div>
          <div>
            <label className="text-xs font-semibold text-brand-ink/70">Nombre del aliado</label>
            <input required data-testid="alianza-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 w-full border border-[#E5E5E5] rounded-sm px-3 py-2 text-sm outline-none focus:border-brand-magenta" />
          </div>
        </div>
        <button type="submit" data-testid="save-alianza-btn" className="mt-4 inline-flex items-center gap-2 bg-brand-magenta text-white font-semibold px-5 py-2.5 rounded-sm hover:bg-brand-orange"><Plus size={16} /> {editingId ? "Guardar" : "Agregar"}</button>
      </form>

      {grupos.map((g) => (
        <div key={g} className="mb-6">
          <h3 className="font-heading text-base font-bold text-brand-ink mb-2">{g}</h3>
          <div className="grid grid-cols-1 gap-2">
            {items.filter((i) => i.grupo === g).map((a) => (
              <div key={a.id} data-testid={`admin-alianza-${a.id}`} className="bg-white border border-[#E5E5E5] rounded-sm px-4 py-2.5 flex items-center gap-3">
                <span className="flex-1 text-brand-ink">{a.name}</span>
                <button data-testid={`edit-alianza-${a.id}`} onClick={() => edit(a)} className="p-1.5 text-brand-ink hover:text-brand-magenta"><Pencil size={15} /></button>
                <button data-testid={`delete-alianza-${a.id}`} onClick={() => remove(a.id)} className="p-1.5 text-brand-ink hover:text-red-600"><Trash2 size={15} /></button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminAlianzas;
